import Actor from "./Actor";

export default class Town extends Actor {
  constructor(props) {
    super({
      ...props,
      type: "town",
    });
  }
}
